interface WrappedValue {
  value: any;
}

const wrapValue = (
  value: any,
  additionalFields?: {
    lastModified?: string | null;
  },
): WrappedValue => ({
  value,
  ...additionalFields,
});

export const writeToCache = (
  key: string,
  value: any,
  additionalFields?: {
    lastModified?: string | null;
  },
) => {
  localStorage.setItem(key, JSON.stringify(wrapValue(value, additionalFields)));
  return value;
};

export const getFromCache = (key: string) => {
  const item = localStorage.getItem(key);

  const parsedItem = item && JSON.parse(item);

  return parsedItem ? parsedItem : { value: null };
};
